import { useEffect } from "react";

export default function CalendarioNuevo({ unidades, fecha, onFechaCambio }) {
  useEffect(() => {
    window.mountCalendario?.("calendario", {
      unidades,
      fecha: fecha?.toDate ? fecha.toDate() : fecha || new Date(),
    });
  }, [unidades, fecha]);

  useEffect(() => {
    const handler = (event) => {
      onFechaCambio?.(event.detail.fecha);
    };

    window.addEventListener("calendario:cambiarFecha", handler);

    return () => {
      window.removeEventListener("calendario:cambiarFecha", handler);
    };
  }, [onFechaCambio]);

  return <div id="calendario"></div>;
}